export default __webpack_public_path__ + "./images/sb.1fcd0c5e.png";